<template>
    <Layout>
        <section class="section">
            <div class="container">
                <div class="important-deadlines">
                    <h2>Important Deadlines</h2>
                    <div class="row">
                        <ul class="deadlines text-center">
                            <li
                                class="deadline col-md-4 animated icon-box"
                                data-animation="fadeIn"
                            >
                                <img
                                    class="icon"
                                    src="/assets/img/icons/new-user.svg"
                                    alt=""
                                    width="50"
                                />
                                <h6>Registration, presenting companies</h6>
                                <p v-html="conferenceTextData.presenters_registration_deadline"></p>
                            </li>

                            <li
                                class="deadline col-md-4 animated icon-box"
                                data-animation="fadeIn"
                                data-delay="100"
                            >
                                <img
                                    class="icon"
                                    src="/assets/img/icons/new-user.svg"
                                    alt=""
                                    width="50"
                                />
                                <h6>Registration, Investors</h6>
                                <p v-html="conferenceTextData.investors_registration_deadline"></p>
                            </li>
                            
                            <li
                                class="deadline col-md-4 animated icon-box"
                                data-animation="fadeIn"
                                data-delay="200"
                            >
                                <img
                                    class="icon"
                                    src="/assets/img/icons/download-webex.png"
                                    alt=""
                                    width="50"
                                />
                                <span
                                    class="icon section-icon icon-seo-icons-05"
                                ></span>
                                <h6>Presentations</h6>
                                <p v-html="conferenceTextData.presentations_deadline"></p>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </section>
    </Layout>
</template>

<script>
import Layout from "@/components/layouts/Layout.vue";
import { mapGetters } from "vuex";

export default {
    name: "ImportantDeadlines",
    components: { Layout },
    computed: {
        ...mapGetters(["conferenceTextData"])
    }
};
</script>
